import useDownloadGroupFile from 'api/codeGroup/downloadFile/useDownloadGroupFile';
import useCodeGroupDelete from 'api/codeGroup/useCodeGroupDelete/useCodeGroupDelete';
import useCodeGrouplist from 'api/codeGroup/useCodeGrouplist/useCodeGrouplist';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CodeGroupEditModal from 'components/shared/Modals/codeGroup/CodeGroupEditModal/CodeGroupEditModal';
import CodeGroupInsertModal from 'components/shared/Modals/codeGroup/CodeGroupInsertModal/CodeGroupInsertModal';
import CodeGroupUploadFileModal from 'components/shared/Modals/codeGroup/CodeGroupUploadFileModal/CodeGroupUploadFileModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCodeGroupTableColumns from 'hooks/codeGroup/useCodeGroupTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CodeGroup = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCodeGroupList, loading, codeGroupList, pageRef] =
    useCodeGrouplist();
  const [downloadGroupFile, downloadLoading] = useDownloadGroupFile();

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCode, setEditChosenCode] = useState({});
  const [uploadChosenGroup, setUploadChosenGroup] = useState({});
  const [isUploadFileModalOpen, setIsUploadFileModalOpen] = useState(false);

  const tableRef = useRef(null);

  const [deleteRequest] = useCodeGroupDelete();
  const navigate = useNavigate();
  const { can } = usePermissions();

  const groupCodePermissions =
    permissions.general.categories.globalSettings.coddingSettings.groupCode;

  const canCreate = can(groupCodePermissions.create);
  const canEdit = can(groupCodePermissions.edit);
  const canDownload = can(groupCodePermissions.download);
  const canUpload = can(groupCodePermissions.upload);
  const canViewValues = can(groupCodePermissions.values.view);
  const canDelete = can(groupCodePermissions.delete);

  useEffect(() => {
    getCodeGroupList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCodeGroupList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/codingAttribute/${row.id}`),
    [],
  );
  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );
  const editItem = useCallback(
    row => () => {
      setEditChosenCode(row);
      setIsEditModalOpen(true);
    },
    [],
  );
  const uploadItem = useCallback(
    row => () => {
      setUploadChosenGroup(row);
      setIsUploadFileModalOpen(true);
    },
    [],
  );
  const downloadItem = useCallback(
    row => () => {
      downloadGroupFile({
        groupGuid: row?.id,
        groupTitle: row?.title,
      });
    },
    [],
  );

  const [columnsData] = useCodeGroupTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    uploadItem,
    downloadItem,
    tableRef,
    {
      canViewValues,
      canEdit,
      canUpload,
      canDownload,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getCodeGroupList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCodeGroupList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCodeGroupList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(codeGroupList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={codeGroupList[page]}
          rows={codeGroupList[page]}
          pageSize={pageSize}
          isDeletable
          isLoading={loading}
          addLable={canCreate ? 'ثبت گروه کد' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      <DeleteModal
        open={isDeleteModalOpen}
        handleClose={() => setIsDeleteModalOpen(false)}
        title={deleteChosenLocation.title}
        locationId={deleteChosenLocation.id}
        deleteLoading={deleteLoading}
        onDelete={deleteHandle}
      />

      {canCreate ? (
        <CodeGroupInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCodeGroupList={getCodeGroupList}
        />
      ) : null}

      {canEdit ? (
        <CodeGroupEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenBasket={editChosenCode}
          getCodeGroupList={getCodeGroupList}
        />
      ) : null}

      {canUpload ? (
        <CodeGroupUploadFileModal
          open={isUploadFileModalOpen}
          uploadChosenGroup={uploadChosenGroup}
          handleClose={() => setIsUploadFileModalOpen(false)}
        />
      ) : null}
    </>
  );
};

export default CodeGroup;
